import React from "react";
import MainCard from "../Cards/MainCard";
import { Card, Col, Placeholder, Row, Spinner, Table } from "react-bootstrap";

const TransactionOrderLogSkeleton = () => {
  return (
    <MainCard>
      {/* Header with filters */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Placeholder as="h5" animation="wave" className="mb-0">
          <Placeholder xs={4} />
        </Placeholder>
        <div className="d-flex gap-3 flex-wrap">
          {[1, 2, 3].map((i) => (
            <Placeholder
              key={i}
              animation="wave"
              className="rounded"
              style={{
                width: "200px",
                height: "38px",
                backgroundColor: "#e9ecef", // thoda grey
              }}
            />
          ))}
        </div>
      </div>

      <div className="p-3 border rounded">
        {/* Table Rows Skeleton */}
        {[...Array(5)].map((_, i) => (
          <Row key={i} className="align-items-center mb-3 border-bottom pb-2">
            {/* Applicant */}
            <Col xs={3}>
              <div className="d-flex align-items-center gap-2">
                <Placeholder
                  as="div"
                  animation="wave"
                  className="rounded-circle bg-secondary"
                  style={{ width: "35px", height: "35px" }}
                />
                <Placeholder as="div" animation="wave" className="w-75">
                  <Placeholder xs={8} /> <Placeholder xs={6} />
                </Placeholder>
              </div>
            </Col>

            {/* Status */}
            <Col xs={2} className="text-center">
              <Placeholder.Button variant="secondary" xs={6} />
            </Col>

            {/* Experience */}
            <Col xs={2} className="text-center">
              <Placeholder as="div" animation="wave" className="w-50">
                <Placeholder xs={6} />
              </Placeholder>
            </Col>

            {/* License */}
            <Col xs={2} className="text-center">
              <Placeholder as="div" animation="wave" className="w-75">
                <Placeholder xs={8} />
              </Placeholder>
            </Col>

            {/* Background */}
            <Col xs={2} className="text-center">
              <Placeholder.Button variant="secondary" xs={8} />
            </Col>
          </Row>
        ))}
      </div>
    </MainCard>
  );
};

export default TransactionOrderLogSkeleton;
